import workSessionMixin from "@/workSessions/mixins/workSessionMixin";

export default {
    mixins : [workSessionMixin],
    async mounted() {
        if(!this.$workSessions.loading){
            await this.$workSessions.performSessionCheck();
        }
    }
}